var map = {
	"./account-balance.svg": [
		965822,
		5822
	],
	"./add-campaign-setting.svg": [
		320407,
		2788
	],
	"./add-circle.svg": [
		364694,
		4694
	],
	"./add-circleV2.svg": [
		50334,
		334
	],
	"./add-device.svg": [
		255780,
		5780
	],
	"./add-element.svg": [
		261590,
		1590
	],
	"./add-icon.svg": [
		44509,
		4509
	],
	"./add-square.svg": [
		140587,
		587
	],
	"./add.svg": [
		4473,
		4473
	],
	"./after-payments.svg": [
		402778,
		2778
	],
	"./alarm.svg": [
		696047,
		6047
	],
	"./alert-error.svg": [
		812111,
		2111
	],
	"./alert-success.svg": [
		631348,
		1348
	],
	"./alert-warning.svg": [
		20097,
		97
	],
	"./apply-filter.svg": [
		857591,
		7591
	],
	"./arrow-down.svg": [
		927952,
		7952
	],
	"./arrow-icon.svg": [
		874079,
		4079
	],
	"./arrow-left.svg": [
		859423,
		9423
	],
	"./arrow-right.svg": [
		686010,
		6010
	],
	"./arrow-up-right.svg": [
		683218,
		837
	],
	"./attach.svg": [
		508519,
		8519
	],
	"./bag-cash.svg": [
		95186,
		5186
	],
	"./bank.svg": [
		996274,
		6274
	],
	"./bar-report.svg": [
		272118,
		2118
	],
	"./bar.svg": [
		611335,
		1335
	],
	"./base-icon.svg": [
		326331,
		6331
	],
	"./beer-count-one.svg": [
		958131,
		8131
	],
	"./beer.svg": [
		183926,
		3926
	],
	"./blocked.svg": [
		980400,
		400
	],
	"./brazil.svg": [
		707590,
		7590
	],
	"./buyer-recharge.svg": [
		315929,
		5929
	],
	"./calendar-date.svg": [
		473407,
		3407
	],
	"./calendar-time.svg": [
		306304,
		6304
	],
	"./camera.svg": [
		201749,
		1749
	],
	"./cart.svg": [
		814194,
		4194
	],
	"./cash-bag.svg": [
		894004,
		4004
	],
	"./cash-flow.svg": [
		868130,
		8130
	],
	"./cash-withdrawal.svg": [
		266631,
		6631
	],
	"./chair-table.svg": [
		162380,
		2380
	],
	"./chair.svg": [
		151119,
		1119
	],
	"./chat.svg": [
		195050,
		5050
	],
	"./check-2.svg": [
		630109,
		109
	],
	"./check-circle.svg": [
		818141,
		8141
	],
	"./check-icon.svg": [
		240386,
		386
	],
	"./check-payment-give.svg": [
		307441,
		7441
	],
	"./check-small.svg": [
		66258,
		6258
	],
	"./check.svg": [
		915216,
		5216
	],
	"./chevron-arrow.svg": [
		547197,
		7197
	],
	"./chevron-back.svg": [
		861595,
		1595
	],
	"./chevron-double-left.svg": [
		27265,
		7265
	],
	"./chevron-double-right.svg": [
		880396,
		396
	],
	"./chevron-down.svg": [
		242262,
		2262
	],
	"./chevron-down2.svg": [
		381464,
		1464
	],
	"./chevron-right.svg": [
		299968,
		9968
	],
	"./chevron-up-down.svg": [
		321050,
		1050
	],
	"./chevron-up.svg": [
		652077,
		2077
	],
	"./clean.svg": [
		978763,
		8763
	],
	"./clear.svg": [
		450223,
		223
	],
	"./cloche.svg": [
		185958,
		3577
	],
	"./clock-campaign.svg": [
		864733,
		4733
	],
	"./clock.svg": [
		74330,
		4330
	],
	"./close-full-screen.svg": [
		753399,
		3399
	],
	"./close.svg": [
		240828,
		828
	],
	"./closeV2.svg": [
		308388,
		8388
	],
	"./color-circle.svg": [
		430842,
		842
	],
	"./convertion.svg": [
		944289,
		4289
	],
	"./copy.svg": [
		793439,
		5820
	],
	"./copy2.svg": [
		751407,
		1407
	],
	"./costumer.svg": [
		131092,
		1092
	],
	"./costumers.svg": [
		412703,
		2703
	],
	"./couvert.svg": [
		437622,
		7622
	],
	"./data-export-dark.svg": [
		520212,
		212
	],
	"./data-export.svg": [
		615919,
		5919
	],
	"./delete.svg": [
		949905,
		9905
	],
	"./delivery-person.svg": [
		118742,
		8742
	],
	"./delivery.svg": [
		125632,
		5632
	],
	"./desk-resource.svg": [
		13064,
		3064
	],
	"./disconnect.svg": [
		356446,
		6446
	],
	"./dollar-money.svg": [
		942081,
		2081
	],
	"./download-2.svg": [
		650773,
		773
	],
	"./download.svg": [
		131160
	],
	"./drag.svg": [
		75958,
		5958
	],
	"./drop-percentage.svg": [
		398808,
		8808
	],
	"./edit-square.svg": [
		688940,
		8940
	],
	"./edit.svg": [
		693116,
		3116
	],
	"./email-icon.svg": [
		356866,
		6866
	],
	"./email.svg": [
		884176,
		4176
	],
	"./empty-search.svg": [
		722032,
		2032
	],
	"./empty-state.svg": [
		124747,
		4747
	],
	"./error.svg": [
		748714,
		8714
	],
	"./exchange.svg": [
		946895,
		6895
	],
	"./external.svg": [
		352365,
		2365
	],
	"./female.svg": [
		188200,
		8200
	],
	"./file-check.svg": [
		23097,
		3097
	],
	"./file-excel.svg": [
		87092,
		7092
	],
	"./file-pdf.svg": [
		699275,
		9275
	],
	"./files-multiple.svg": [
		733318,
		3318
	],
	"./filter.svg": [
		618742,
		6361
	],
	"./financial-report.svg": [
		559348,
		9348
	],
	"./fiscal-printer.svg": [
		120157,
		157
	],
	"./fiscal.svg": [
		321366,
		1366
	],
	"./french.svg": [
		688320,
		8320
	],
	"./full-screen.svg": [
		953956,
		3956
	],
	"./future-wallet.svg": [
		384861,
		4861
	],
	"./gift-card.svg": [
		333241,
		3241
	],
	"./graph.svg": [
		352172,
		2172
	],
	"./help.svg": [
		152601,
		2601
	],
	"./history.svg": [
		307184,
		7184
	],
	"./home-circle.svg": [
		968522,
		8522
	],
	"./home.svg": [
		69373,
		9373
	],
	"./hop-flower.svg": [
		175975,
		5975
	],
	"./image-outline.svg": [
		938570,
		8570
	],
	"./image-stock.svg": [
		562386,
		2386
	],
	"./inconsistencies.svg": [
		387095,
		7095
	],
	"./info-all-black.svg": [
		292664,
		2664
	],
	"./info-outlined.svg": [
		969339,
		9339
	],
	"./info.svg": [
		151444
	],
	"./kitchen.svg": [
		238032,
		8032
	],
	"./link.svg": [
		302040,
		2040
	],
	"./list.svg": [
		756528,
		4147
	],
	"./location-circle.svg": [
		413210,
		3210
	],
	"./mail.svg": [
		789805,
		9805
	],
	"./male.svg": [
		711967,
		1967
	],
	"./medal.svg": [
		746033,
		6033
	],
	"./megaphone.svg": [
		406666,
		6666
	],
	"./mesa.svg": [
		175694,
		5694
	],
	"./mexico.svg": [
		666361,
		1123
	],
	"./minus.svg": [
		142384,
		2384
	],
	"./money-atm.svg": [
		13115,
		3115
	],
	"./money-bag.svg": [
		947265,
		9646
	],
	"./money-bags.svg": [
		572272,
		2272
	],
	"./money-box.svg": [
		95940,
		5940
	],
	"./money-bubble.svg": [
		758059,
		8059
	],
	"./money-circle.svg": [
		165513,
		5513
	],
	"./money-exchange.svg": [
		393254,
		3254
	],
	"./money-sign.svg": [
		321930,
		9549
	],
	"./money-withdraw-in.svg": [
		230289,
		289
	],
	"./money-withdraw-out.svg": [
		860960,
		960
	],
	"./money.svg": [
		472348,
		2348
	],
	"./more-vertical.svg": [
		870194,
		194
	],
	"./multivendor.svg": [
		529737,
		9737
	],
	"./music.svg": [
		67897,
		7897
	],
	"./navigate-page.svg": [
		422227,
		2227
	],
	"./options.svg": [
		758834,
		8834
	],
	"./order-alphabetic.svg": [
		53600,
		3600
	],
	"./order-clock.svg": [
		794577,
		4577
	],
	"./order.svg": [
		482688,
		2688
	],
	"./other-gender.svg": [
		605504,
		5504
	],
	"./pdv-money.svg": [
		228337,
		8337
	],
	"./pdv-zig.svg": [
		967495,
		7495
	],
	"./pencil-circle.svg": [
		551236,
		1236
	],
	"./percentage.svg": [
		784616,
		4616
	],
	"./person.svg": [
		261575,
		1575
	],
	"./phone.svg": [
		850884,
		884
	],
	"./price.svg": [
		48687,
		8687
	],
	"./printer.svg": [
		337236,
		7236
	],
	"./product-add.svg": [
		575431,
		5431
	],
	"./product-cancel.svg": [
		930948,
		948
	],
	"./product-check.svg": [
		10618,
		618
	],
	"./product-details.svg": [
		956020,
		6020
	],
	"./product-return.svg": [
		113096,
		3096
	],
	"./product-sells.svg": [
		638157,
		8157
	],
	"./product.svg": [
		28965,
		8965
	],
	"./products.svg": [
		743820,
		3820
	],
	"./promotions.svg": [
		83218,
		3218
	],
	"./qrcode-circle.svg": [
		512171,
		2171
	],
	"./rasps.svg": [
		960181,
		181
	],
	"./recharge-info.svg": [
		861836,
		1836
	],
	"./refresh.svg": [
		958929,
		8929
	],
	"./refreshV2.svg": [
		606341,
		6341
	],
	"./refund-reason.svg": [
		328531,
		8531
	],
	"./refund.svg": [
		498150,
		8150
	],
	"./relations.svg": [
		249383,
		9383
	],
	"./remove-circle.svg": [
		389853,
		9853
	],
	"./reset-positions.svg": [
		449290,
		9290
	],
	"./resize.svg": [
		491744,
		1744
	],
	"./return-money.svg": [
		409033,
		9033
	],
	"./sale-slip-disabled.svg": [
		107921,
		7921
	],
	"./sale-slip.svg": [
		813532,
		3532
	],
	"./sales.svg": [
		583392,
		3392
	],
	"./search-dark.svg": [
		472329,
		2329
	],
	"./search.svg": [
		604628,
		4628
	],
	"./select-arrow-right.svg": [
		377277,
		7277
	],
	"./selector-arrow-right.svg": [
		880242,
		242
	],
	"./send-icon.svg": [
		60604,
		604
	],
	"./service-report.svg": [
		593752,
		3752
	],
	"./settings.svg": [
		28975,
		8975
	],
	"./settingsV2.svg": [
		887019,
		7019
	],
	"./shield-security.svg": [
		366830,
		6830
	],
	"./shine.svg": [
		603061,
		3061
	],
	"./short-arrow-down.svg": [
		753627,
		6008
	],
	"./smartphone.svg": [
		188145,
		8145
	],
	"./spain.svg": [
		236675,
		6675
	],
	"./star.svg": [
		245768,
		5768
	],
	"./stock-report.svg": [
		357245,
		7245
	],
	"./stock.svg": [
		847602,
		7602
	],
	"./store.svg": [
		412323,
		2323
	],
	"./success.svg": [
		363065,
		3065
	],
	"./sun.svg": [
		964658,
		4658
	],
	"./sync-warning.svg": [
		891794,
		1794
	],
	"./synchronize.svg": [
		416210,
		6210
	],
	"./t-money.svg": [
		477139,
		7139
	],
	"./table-chair.svg": [
		908508,
		8508
	],
	"./table-money-sig.svg": [
		836867,
		6867
	],
	"./table-money.svg": [
		229723,
		9723
	],
	"./table.svg": [
		725452,
		3071
	],
	"./tag-alert.svg": [
		490849,
		849
	],
	"./three-dots-icon.svg": [
		322709,
		2709
	],
	"./tickets.svg": [
		364343,
		4343
	],
	"./timezone.svg": [
		729801,
		9801
	],
	"./totem.svg": [
		76739,
		6739
	],
	"./trash.svg": [
		770126,
		126
	],
	"./trashV2.svg": [
		162390,
		2390
	],
	"./travel-map.svg": [
		30577,
		577
	],
	"./truck.svg": [
		651289,
		1289
	],
	"./unlock.svg": [
		753220,
		3220
	],
	"./upload.svg": [
		319955,
		9955
	],
	"./uploaded-file.svg": [
		861203,
		1203
	],
	"./usa.svg": [
		4469,
		4469
	],
	"./user-delete.svg": [
		35847,
		5847
	],
	"./user-money.svg": [
		136662,
		6662
	],
	"./user.svg": [
		179145,
		9145
	],
	"./users-dark.svg": [
		940981,
		981
	],
	"./users.svg": [
		103624,
		3624
	],
	"./utensil.svg": [
		514078,
		4078
	],
	"./view-details.svg": [
		129126,
		9126
	],
	"./view.svg": [
		285539,
		5539
	],
	"./wallet.svg": [
		525591,
		5591
	],
	"./warning-icon.svg": [
		474406,
		4406
	],
	"./warning-triangle.svg": [
		754453,
		4453
	],
	"./warning-triangular.svg": [
		23374,
		3374
	],
	"./warning.svg": [
		782740,
		2740
	],
	"./whatsapp.svg": [
		938618,
		8618
	],
	"./withdraw.svg": [
		423646,
		3646
	],
	"./ze-delivery-tag.svg": [
		702907,
		2907
	],
	"./ze-delivery.svg": [
		974524,
		4524
	],
	"./zig-cash.svg": [
		885554,
		5554
	],
	"./zig-person.svg": [
		665660,
		5660
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629532;
module.exports = webpackAsyncContext;